export const TrackYourAIVisibilityCSS = {
  root: {
    display: 'flex',
    maxWidth: 900,
    mx: 'auto',
    pb: 4,
    // pt: 2
  },

  card: {
    flex: 2,
    // p: '24px',
    borderRadius: '12px'
  },

  title: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-18)',
    lineHeight: 'var(--line-height-28)',
    textAlign: 'center',
    color: 'var(--color-text-muted)'
  },

  titleHighlight: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 'var(--font-size-18)',
    lineHeight: 'var(--line-height-28)',
    textAlign: 'center',
    background:
      'linear-gradient(180deg, var(--color-primary) 0%, var(--color-secondary) 170%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text', // fallback
    color: 'transparent'
  },

  headerWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  /** Row below title: Buy more sites button + sites available text, centered */
  headerActionRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '16px'
  },

  /** Primary action button for "Buy more sites" – reads as button, not badge */
  buyMoreSitesButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    background: 'var(--color-secondary)',
    color: 'var(--color-primary)',
    padding: '10px 20px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    border: 'none',
    transition: 'background-color 0.2s, box-shadow 0.2s',
    '&:hover': {
      backgroundColor: '#1EB89A',
      boxShadow: '0 2px 8px rgba(37, 211, 177, 0.35)'
    }
  },

  description: {
    mt: 1,
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-tertiary)',
    maxWidth: '90%',
    marginLeft: 'auto',
    marginRight: 'auto'
  },

  labelRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginBottom: '6px'
  },

  label: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)'
  },

  tooltipText: {
    fontFamily: 'Inter',
    fontSize: '13px',
    color: 'var(--color-text-muted)'
  },

  helpIcon: {
    width: '16px',
    height: '16px',
    color: 'rgba(168, 166, 191, 1)',
    '&:hover': {
      color: 'var(--color-primary)'
    }
  },

  inputWrapper: {
    display: 'flex',
    gap: 1,
    flexWrap: 'wrap',
    border: '1px solid var(--color-border-light2)',
    borderRadius: '8px',
    p: 1
  },

  inputField: {
    flex: 1,
    minWidth: 150
  },

  textArea: {
    bgcolor: '#FAFAFA',
    borderRadius: '8px'
  },

  topicCount: {
    mt: 0.5,
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 'var(--line-height-18)',
    color: 'var(--color-text-tertiary)'
  },

  exampleTopic: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-purple-rich)',
    marginTop: '6px',
    textAlign: 'left'
  },

  primaryButton: (isDisable) => ({
    mt: 2,
    py: '12px',
    px: '18px',
    borderRadius: '6px',
    background: isDisable
      ? 'none'
      : 'linear-gradient(176deg, var(--color-primary) 10%, var(--color-secondary) 95%)',
    textTransform: 'none',
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-white)'
  }),

  secondaryText: {
    mt: 1.5,
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-purple)',
    cursor: 'pointer'
  },

  sideBox: {
    flex: 1,
    p: '24px',
    gap: '24px',
    borderTopRightRadius: '12px',
    borderBottomRightRadius: '12px',
    background: 'var(--color-bg-muted-alt)',
    marginTop: '3rem',
    maxHeight: 'fit-content',
    maxWidth: '265px',
    boxShadow: '3px 3px 22px 0px #34345314'
  },

  sideTitle: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-muted)',
    textAlign: 'left'
  },

  sideDescription: {
    mt: 1,
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    textAlign: 'left'
  },

  sideLinkWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    mt: 1,
    cursor: 'pointer'
  },

  sideLink: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  sideLinkIcon: {
    fontSize: 'var(--font-size-18)',
    color: 'var(--color-text-mid)'
  },
  competitorsChip: {
    padding: '0px 6px 2px 6px',
    gap: '6px',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-heading)',
    backgroundColor: 'var(--color-bg-muted-alt)',
    height: 28,
    whiteSpace: 'nowrap',
    textOverflow: 'inherit',
    borderRadius: '4px'
  },
  remainingSlotText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-tertiary)'
  },

  /** Muted slot count next to the button in header action row */
  remainingSlotMuted: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-tertiary)'
  },
  accordionHeader: (expanded: boolean) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 0',
    cursor: 'pointer',
    borderBottom: expanded ? 'none' : '1px solid #EAEAEA'
  }),
  accordionTitle: {
    fontSize: '15px',
    fontWeight: 700,
    color: '#2B2F36'
  },
  accordionCollapseBox: {
    paddingBottom: '16px',
    borderBottom: '1px solid #EAEAEA'
  },
  accordionIcon: {
    color: '#667085'
  }
};

export const upgradeToProBannerSx = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'var(--color-success-bg-ultra)',
    borderRadius: '12px',
    padding: '16px 20px',
    gap: '12px',
    width: '100%',
    maxWidth: '900px',
    marginLeft: 'auto',
    marginRight: 'auto',
    border: '1px solid var(--color-success-border)'
  },
  leftContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    flex: 1
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '24px'
  },
  icon: {
    fontSize: 'var(--font-size-24)',
    color: 'var(--color-primary)',
    marginTop: '3px'
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },
  title: {
    fontSize: 'var(--font-size-18)',
    fontWeight: 700,
    color: 'var(--color-primary)',
    textAlign: 'left'
  },
  description: {
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    color: 'var(--color-primary)',
    lineHeight: 1.5,
    textAlign: 'left'
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  button: {
    backgroundColor: 'var(--color-primary)',
    color: 'var(--color-white)',
    borderRadius: '8px',
    padding: '8px 18px',
    textTransform: 'none',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    '&:hover': { backgroundColor: '#0E0135' }
  }
};
